// Task type options.
//
// Mirrors the allow-list enforced by the backend recurrence-rules service
// (see services/api/services/task_recurrence_rules.service.js
//  ALLOWED_TASK_TYPES). Keep these two in sync — adding a value here
// without updating the backend will produce 400 ValidationError responses
// when saving a recurrence rule.
export const TASK_TYPE_OPTIONS = [
  { value: "cleaning", label: "Cleaning" },
  { value: "inspection", label: "Inspection" },
  { value: "maintenance", label: "Maintenance" },
  { value: "other", label: "Other" },
];

export const TASK_TYPE_LABELS = TASK_TYPE_OPTIONS.reduce((acc, opt) => {
  acc[opt.value] = opt.label;
  return acc;
}, {});

// Display label for a row's `task_type` (new column) falling back to the
// legacy `type` column ('workorder' for pre-Tasks rows). Keeps existing
// ~5,000 production rows displaying correctly without a data backfill.
export const getTaskTypeLabel = (row) => {
  if (row?.task_type && TASK_TYPE_LABELS[row.task_type]) {
    return TASK_TYPE_LABELS[row.task_type];
  }
  if (row?.type === "workorder" || (!row?.task_type && !row?.type)) {
    return "Work Order";
  }
  return row?.task_type || "—";
};
